import yamlJS from 'js-yaml';
import type { DashboardFilter as IDashboardFilter } from '../../lib/api/looker/dto';

export interface IDashboardElement {
  title?: string;
  body_text?: string;
}

export interface IDashboardLookML {
  dashboard: string;
  description: string;
  preferred_slug?: string;
  title: string;
  elements: IDashboardElement[];
  filters: IDashboardFilter[];
}

export const dashboardLookmlJsonToYaml = (jsonDefinition: IDashboardLookML[]): string | undefined => {
  if (jsonDefinition) {
    try {
      const yamlDefinition = yamlJS.dump(jsonDefinition);
      return yamlDefinition;
    } catch {
      throw new Error('Error converting JSON to YAML:');
    }
  }
};

export const dashboardLookmlYamlToJson = (yamlDefinition: string): IDashboardLookML[] | undefined => {
  if (!yamlDefinition) {
    return;
  }

  try {
    const jsonDefinition = yamlJS.load(yamlDefinition) as IDashboardLookML[];
    return jsonDefinition;
  } catch (e: unknown) {
    console.error(e);
    throw new Error('Error converting YAML to JSON:');
  }
};

export const resolveDashboardLookmlJson = (jsonDefinitions: (IDashboardLookML[] | undefined)[]) => {
  return jsonDefinitions.reduce((acc, curr) => {
    if (!acc?.length) {
      return curr;
    }

    if (acc && curr?.[0]) {
      const { elements: currElements, ...rest } = curr[0];
      acc[0] = {
        ...acc[0],
        ...rest,
        elements: [...(acc[0].elements ?? []), ...(currElements ?? [])],
      };
    }

    return acc;
  }, [] as IDashboardLookML[]);
};
